<template> 
   <div :class="['content-container', 'ipad', {'desktop': !this.isIpad}]">
       <NavBar title="Select disease state"></NavBar>
        <!-- Content -->
        <div class="container disease-state-container">
            <template v-if="!statesAvailable">
                    <div class="alert alert-danger" role="alert">
                        There are no disease states to show.
                    </div>   
                </template> 
            <div class="grid-container" v-else>
                <template v-for="d in allowedStates">
                    <router-link
                            v-if="d.parent[0].target_id !== null"
                            @click.native="trackEvent"
                            :to="'timeline/diseasestate/'+ d.name[0].value + ''"
                            class="grid-item disease"
                            :class="getDiseaseState(d.parent[0].target_id, 'name', 'value') | toClassName"
                            :key="d.uuid[0].value"
                            data-category="Disease State Navigation"
                            data-action="button_press"
                            :data-event="d.name[0].value"
                    >
                        <h3 class="subtitle">{{ getDiseaseState(d.parent[0].target_id, 'name', 'value')}}</h3>
                        <h2 class="title compact">{{ d.name[0].value }}</h2>
                    </router-link>
                </template>
            </div>
        </div>

        <!-- Background Image -->
        <div class="img-bg">
            <img src="img/backgrounds/timeline.png" class="bottom-center">
        </div>
   </div>
</template>

<script>
    import NavBar from './components/NavBar';
    // import ReusableDisclaimer from './components/ReusableDisclaimerModal.vue';
    import getTaxonomyData from './components/getTaxonomyData'; 

    export default {
        extends: getTaxonomyData,
        name: 'DiseaseState',
        components: {
            NavBar
        },
        computed: {
            diseaseStates() {return this.$store.getters.getDiseaseStates},
            allowedStates() { return this.allowedProduct() },
            statesAvailable() {return this.allowedStates.length > 0}
        },
        filters: {
            toClassName: function(str) {
                let s = str.replace(' ', '-').replace("'", ""); 
                return s.toLowerCase(); 
            },
        },
        beforeRouteLeave (to, from, next) {
          if (to.params.filtervalue) {
            let page = 'Disease State Page - ' + to.params.filtervalue;
            this.$root.track("callback://screenname_" + page);
          }
          next();
        },
        methods: {
            getDiseaseState: function(targetId, key, property) {
                let diseaseStates = this.$store.getters.getDiseaseStates; 
                let states = diseaseStates.filter( el => el.tid[0].value === targetId); 
                return states.length < 1 ? '' : states[0][key][0][property] ;
            },
            allowedProduct: function() {
                return this.$store.getters.getAllowedDiseaseStates;
            },
            trackEvent: function(event) {
                const route = this.$router.currentRoute.path;
                const target = event.target;
                const category = target.getAttribute('data-category') || 
                                target.parentElement.getAttribute('data-category');
                const eventName = target.getAttribute('data-event') || 
                                target.parentElement.getAttribute('data-event');
                
                // For debugging
                console.log(`Tracking event: ${eventName} in category ${category}`);
                
                // Track the event with proper parameters
                this.analytics.trackEvent(route, 'navigation', target);
                
                // If this is a disease state navigation, also track as a page view with proper title and class
                if (category === 'Disease State Navigation') {
                    const pageTitle = `Disease State - ${eventName}`;
                    const screenClass = `DiseaseState${eventName.replace(/\s+/g, '')}Screen`;
                    
                    // This will ensure your analytics dashboard captures this page/screen combination
                    this.analytics.trackRoute(route, pageTitle, screenClass);
                }
            },
            onAccepted: function() {
                // const disclaimer = this.disclaimerParams;
                this.disclaimerParams = null;
            }
        }
    }
</script>

<style>
    .grid-container {
        grid-auto-rows: minmax(auto, 25%) !important;
    }
</style>